import { isNonEmptyString } from './commons';

const getSearchCount = (panelSearch) => {
  return isNonEmptyString(panelSearch) ? 1 : 0;
};

export default getSearchCount;
